export default "__VITE_PUBLIC_ASSET__5c82ea28__"